module.exports = __webpack_public_path__ + "static/img/3.b706b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/3.png
// module id = h9/Y
// module chunks = 12